// extracted by mini-css-extract-plugin
export var expContainer = "experience-module--expContainer--M+iLO";
export var experienceBg = "experience-module--experienceBg--rMJfc";
export var expTopText = "experience-module--expTopText--Xi9N8";